import { ErrorConstants } from '../api/error.constants';
import { ARApiError } from '@relayter/core';

export class ErrorFormatterUtil {
    public static formatError(error: ARApiError): string {
        return error?.details || error?.message || ErrorConstants.INTERNAL_SERVER_ERROR_MESSAGE;
    }
}
